// Types
import type { Exhibit } from '../../../server/src/types';

// Utils
import { filterByTranslation } from 'utils/filterGeneric';

export const filterExhibits = (
  exhibits: Exhibit[] | undefined,
  search: string
): Exhibit[] => filterByTranslation(exhibits, search);
